<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-map-marker"
    ></vuse-section-definition>
    <v-container fluid class="content_product1">
      <v-row class="mx-0 mt-4">
        <v-col cols="12" md="12" lg="8" class="px-0">
          <v-row class="mx-0 mt-4">
            <v-col class="mx-2" cols="3.5" sm="3.5">
              <v-text-field
                  hide-details
                  filled
                  class="mt-3"
                  label="Tên trung tâm bảo hành"
                  v-model="warranties_center.name"
                  placeholder="Nhập tên trung tâm bảo hành"
                  @input="debounceInputName"
              ></v-text-field>
            </v-col>
            <v-col class="mx-2" cols="3.5" sm="3.5">
              <v-select
                  hide-details
                  filled
                  class="width-input mt-3"
                  v-model="warranties_center.brand_id"
                  clearable
                  :items="brands"
                  item-text="name"
                  item-value="id"
                  label="Brand"
                  @change="getItem"
              ></v-select>
            </v-col>
            <v-col class="mx-2" cols="3.5" sm="3.5">
              <v-select
                  hide-details
                  filled
                  class="width-input mt-3"
                  v-model="warranties_center.area_id"
                  :items="areas"
                  item-text="name"
                  item-value="id"
                  clearable
                  label="Khu vực"
                  @change="getItem"
              ></v-select>
            </v-col>
            <v-col class="mx-2" cols="3.5" sm="3.5">
              <v-autocomplete
                  hide-details
                  filled
                  class="width-input mt-3"
                  v-model="warranties_center.province_id"
                  :items="provinces"
                  item-text="name"
                  clearable
                  item-value="id"
                  label="Tỉnh thành"
                  @change="getItem"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="12" lg="4" align="right" class="mt-0 mt-md-8">
          <v-btn
              class="mt-1 mt-md-2"
              color="primary"
              align="right"
              @click="addNewByFileExcel"
              v-if="hasPermissions('Import excel warranties_center')"
          >
            Thêm mới bằng file Excel
          </v-btn>
          <v-btn
              class="ml-3 mt-1 mt-md-2 "
              color="primary"
              align="right"
              @click="addNew"
              v-if="hasPermissions('Create warranties_center')"
          >
            Thêm mới
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="dataResult"
              :page.sync="page_number"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              @page-count="pageCount = $event"
          >

            <template v-slot:item.hotline="{ item }" >
              <span class="red--text">{{item.hotline}}</span>
            </template>

            <template v-slot:item.order="{ item }" >
              <v-text-field
                hide-details
                background-color="#EDF2F7"
                filled
                label="Độ ưu tiên"
                v-model="item.order"
                placeholder="Độ ưu tiên"
                @input="debounceUpdateOrder(item.id, item.order)"
              ></v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)" v-if="hasPermissions('Update warranties_center')">
                mdi-pencil
              </v-icon>
              <!-- <v-icon small class="mr-2" @click="reviewItem(item)">
                mdi-eye
              </v-icon> -->
              <v-icon small @click="deleteItem(item)" v-if="hasPermissions('Delete warranties_center')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="d-flex justify-center">
          Thêm mới trung tâm bảo hành bằng file Excel
        </v-card-title>

        <v-card-text>
          <v-row class="mt-5">
            <v-col cols="12">
              <v-file-input
                  label="File Excel"
                  placeholder="File Excel"
                  prepend-icon="mdi-file-excel"
                  @change="fileSelected"
              ></v-file-input>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                      @click="dialog = false"
                  >
                    Hủy
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {GET_LIST_WARRANTIES_CENTER, DELETE_WARRANTIES_CENTER, GET_DATA_SEARCH_WARRANTIES_CENTER, IMPORT_EXCEL_WARRANTIES_CENTER, UPDATE_ORDER_WARRANTIES_CENTER} from '@/store/modules/warranties_center';
import { GET_LIST_BRAND } from "@/store/modules/brand";
import {GET_LIST_AREAS, GET_LIST_PROVINCES} from '@/store/modules/residence'
import {mapGetters} from 'vuex';
import {debounce} from "debounce";

export default {
  data() {
    return {
      dialog:false,
      current_page: 1,
      page_number: 1,
      pageCount: 0,
      itemsPerPage: 10,
      page: "Quản lý trung tâm bảo hành",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý trung tâm bảo hành",
          disabled: true,
        },
        {
          text: "Danh sách trung tâm bảo hành",
          disabled: true,
        },
      ],
      warranty_status: [
        {id:1, name:'CHỜ DUYỆT'},
        {id:2, name:'ĐÃ DUYỆT'},
      ],
      headers: [
        { text: 'ID', value: 'id', align: 'start', },
        {
          text: 'Tên trung tâm bảo hành',
          sortable: false,
          value: 'name',
        },
        { text: 'Khu vực', value: 'area_name', width: "9%" },
        { text: 'Độ ưu tiên', value: 'order', width: "10%" },
        { text: 'Địa chỉ', value: 'address' },
        { text: 'Hotline', value: 'hotline' },
        { text: 'Actions', value: 'actions' },
      ],
      warranties_center: {
        area_id:'',
        brand_id:'',
        province_id:'',
        name:'',
      }
    };
  },
  computed:{
    ...mapGetters({
      listWarrantiesCenter: 'listWarrantiesCenter',
      brands: "brands",
      areas: "areas",
      provinces: "provinces",
      dataResult: "dataSearchWarrantiesCenter",
    })
  },
  watch:{
    'warranties_center.area_id':function (val){
      this.$store.dispatch(`${GET_LIST_PROVINCES}`, val);
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_WARRANTIES_CENTER}`);
    await this.$store.dispatch(`${GET_LIST_BRAND}`);
    await this.$store.dispatch(`${GET_LIST_AREAS}`);

    this.page_number = parseInt(this.$route.query.page_current) || 1
    this.warranties_center.name =  this.$route.query.name || ''
    this.warranties_center.brand_id = parseInt(this.$route.query.brand_id) || ''
    this.warranties_center.area_id = parseInt(this.$route.query.area_id) || ''
    this.warranties_center.province_id = parseInt(this.$route.query.province_id) || ''
    this.params();
  },

  methods: {
    params() {
      let param = {
        name: this.warranties_center.name,
        brand_id: this.warranties_center.brand_id != "-1" ? this.warranties_center.brand_id : null,
        area_id: this.warranties_center.area_id != "-1" ? this.warranties_center.area_id : null,
        province_id: this.warranties_center.province_id != "-1" ? this.warranties_center.province_id : null,
      };
      this.$store.dispatch(GET_DATA_SEARCH_WARRANTIES_CENTER, param);
    },
    replaceWarrantiesCenter() {
      this.$router.replace({
        query: {
          name: this.warranties_center.name,
          brand_id: this.warranties_center.brand_id != "-1" ? this.warranties_center.brand_id : null,
          area_id: this.warranties_center.area_id != "-1" ? this.warranties_center.area_id : null,
          province_id: this.warranties_center.brand_id != "-1" ? this.warranties_center.province_id : null,
          page_current: parseInt(this.page_number),
        }
      })
    },
    debounceInputName: debounce(function (e) {
      this.warranties_center.name = e;
      this.replaceWarrantiesCenter();
      this.params();
    }, 200),

    debounceUpdateOrder: debounce(function (id, order) {
      let param = {
        id: id,
        order: order
      };
      this.$store.dispatch(UPDATE_ORDER_WARRANTIES_CENTER, param).then((data) => {
        if (data) {
          this.debounceInputName(this.warranties_center.name);
        }
      });
    }, 200),

    getItem() {
      this.replaceWarrantiesCenter();
      this.params();
    },
    editItem(id) {
      this.replaceWarrantiesCenter();
      this.$router.push({
        path: '/warranties_center/edit_warranties_center/' + id,
      })
    },
    reviewItem() {

    },
    deleteItem(item) {
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_WARRANTIES_CENTER}`, item.id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_DATA_SEARCH_WARRANTIES_CENTER);
        }
      })
    },
    addNew() {
      this.$router.push('/warranties_center/add_warranties_center')
    },
    addNewByFileExcel(){
      this.dialog = true;
    },
    fileSelected(event) {
      const _this = this;
      console.log(event);
      if (event) {
        let formData = new FormData();
        formData.append("file", event);
        this.$store.dispatch(`${IMPORT_EXCEL_WARRANTIES_CENTER}`, formData).then((data) => {
          if (data && data.data && data.data.status == 1) {
            this.$toasted.success('Thêm mới thành công!', {
              duration:1000,
              position:'top-center'
            })
          }else{
            this.$toasted.error('Thêm mới thất bại!', {
              duration:1000,
              position:'top-center'
            })
          }
        }).catch(() => {
          this.$toasted.error('Thêm mới thất bại!', {
            duration:1000,
            position:'top-center'
          })
        });
      }
      _this.dialog = false;
    },
  }
};
</script>
<style lang="scss">
.content_product1 {
  background: #ffffff !important;
}
.width-input {
  max-width: 240px!important;
}
</style>
